import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DialogService } from 'src/app/services/dialog.service';
import { OpentokService } from 'src/app/services/opentok.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ControlsComponent implements OnChanges {
  @Input('cid') cid: number;
  @Input('m') m: number;
  @Input('enableHangup') enable: boolean;

  camOpen = true;
  micOpen: boolean = false;

  constructor(
    private _opentok: OpentokService,
    private _dialog: DialogService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['m'] && changes['m'].currentValue !== undefined) {
      if (environment.production) this.micOpen = this.m === 0;
      else this.micOpen = false;
    }
  }

  toogleCam(event: boolean) {
    this.camOpen = event
    this._opentok.publisher.publishVideo(this.camOpen);
  }

  changeBackground(event: { type: 'imagen' | 'ofuscado', value: string, camOpen: boolean }) {
    const { type, value, camOpen } = event

    if (value === '') this._opentok.publisher.clearVideoFilter()
    else {
      if (type === 'imagen') this._opentok.publisher.applyVideoFilter({
        type: 'backgroundReplacement',
        backgroundImgUrl: `../../../assets/img/fondos/${value}`
      })
      else this._opentok.publisher.applyVideoFilter({
        type: 'backgroundBlur',
        blurStrength: (value as 'low' | 'high')
      })
    }

    if (!this.camOpen) this.toogleCam(!this.camOpen);
  }

  mute() {
    this.micOpen = !this.micOpen;
    this._opentok.publisher.publishAudio(this.micOpen);
  }

  hangup() {
    this._dialog.createDialog('finish', this.cid, this.m);
  }
}
